import { render, staticRenderFns } from "./Lgx279928282151911424.vue?vue&type=template&id=0811137f&scoped=true&"
import script from "./Lgx279928282151911424.vue?vue&type=script&lang=js&"
export * from "./Lgx279928282151911424.vue?vue&type=script&lang=js&"
import style0 from "./Lgx279928282151911424.vue?vue&type=style&index=0&id=0811137f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811137f",
  null
  
)

export default component.exports